module.exports = __webpack_public_path__ + "static/img/pMRI9.951e9184.png";